<template>
  <div v-show="isOpen" class="Modal -open" :class="modalClasses">
    <span class="Modal__close" @click="closeModal"></span>
    <section class="Modal__dialog" :class="{ 'has-sidebar': sidebar }">
        <div v-if="sidebar" class="Modal__sidebar">
            <slot name="sidebar"></slot>
        </div>
        <button type="button" class="Modal__cancel button btn -medium -clear" @click="closeModal">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" style="display: block; fill: rgb(118, 118, 118); height: 16px; width: 16px;">
                <path fill-rule="evenodd" d="M23.25 24a.744.744 0 0 1-.53-.22L12 13.062 1.28 23.782a.75.75 0 0 1-1.06-1.06L10.94 12 .22 1.28A.75.75 0 1 1 1.28.22L12 10.94 22.72.22a.749.749 0 1 1 1.06 1.06L13.062 12l10.72 10.72a.749.749 0 0 1-.53 1.28"></path>
            </svg>
        </button>
        <header v-if="hasHeader" class="Modal__header">
            <slot name="header"></slot>
        </header>

        <div class="Modal__subHeader">
            <slot name="subheader"></slot>
        </div>

        <div class="Modal__content">
            <slot name="content">
              <icon name="spinner" size="huge" :spin="true"></icon>
            </slot>
        </div>

        <footer v-if="hasFooter" class="Modal__footer">
            <slot name="footer"></slot>
            <button v-if="labels.cancel" type="button" class="button btn -color -clear -medium _ml-" @click="closeModal" :style="buttonStyle(labels.cancel)">
                {{  buttonLabel(labels.cancel) }}
            </button>
            <button v-if="submit" type="button" class="button btn -color -clear -medium _ml-" @click="saveChanges" :style="buttonStyle(labels.submit)" v-submit>
                {{ buttonLabel(labels.submit) }}
            </button>
        </footer>

        <div class="Modal__footerMessage">
            <slot name="footerMessage"></slot>
        </div>
    </section>
  </div>

</template>

<script>
import modalMixin from '../../mixins/modal';

export default {
  mixins: [
    modalMixin,
  ],
};
</script>
